<template>
  <div class="basketball-info">
    <MatchCompany />
    <MatchProject/>
  </div>
</template>

<script>
import MatchCompany from '@comm/components/MatchCompany.vue'
import MatchProject from '@comm/components/MatchProject.vue'
export default {
  name: 'BasketballInfo',
  props: {
    
  },
  data() {
    return {

    }
  },
  components: {
    MatchCompany,
    MatchProject
  },
  mounted() {},
  methods: {
    
  },
  watch: {},
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/comm/components/match/basketball/components/BasketballInfo.vue